import React, {useState} from 'react';
import { InputWithInnerLabel } from 'src/components/ui/inputFields/input-with-label';
import StepperNav from '../stepperNav';
import { createNewServer, editServer } from 'src/api/userInfo';
import { useTranslation } from 'react-i18next'

const SetupIotDatabase = ({step,setStep, type, server, onClose, plantId, isEditServer}) => {
    const [configStatus, setConfigStatus] = useState({});
    const { t } = useTranslation("settings");

    //handle submit
    const addNewServer = async(e) => {
        e.preventDefault();
        //submit form
        // get data from form
        const formData = new FormData(e.target);
        
            try {
                let response;
                if(isEditServer){
                    response= await editServer(plantId, formData)
                }else{
                    response= await createNewServer(plantId, formData)
                }
                if(response?.data && !response?.error){
                    setConfigStatus({success: true, status: `${t('device_management.server_setup.success_message')}`})
                    setTimeout(() => {
                        setConfigStatus({})
                    }, 2000);
                    onClose()
                }else if(response?.error){
                    if(response?.error==="Server does not exits")
                    setConfigStatus({success: false, status: response?.error})
                    setTimeout(() => {
                        setConfigStatus({})
                    }, 3000);
                }
            } catch (error) {
                setConfigStatus({success: false, status: `${t('device_management.server_setup.error_message')}`})
                setTimeout(() => {
                    setConfigStatus({})
                }, 5000);
            }        
    }
        
        
    return ( 
        <>
            {step==2 && (type=='influxdbs' || type === 'influxdb') &&
            <form onSubmit={addNewServer} className=''>
                <h2 className='block text-sm font-semibold text-gray-700'>2. {t('device_management.server_setup.config_iot')}</h2>
            
                <div className="relative grid grid-cols-2 gap-4 pb-6 mt-3" >
                    <InputWithInnerLabel 
                    label={`${t('device_management.server_setup.server_name')}`} name="name" placeholder="Vekin Db" required={true}
                    defaultValue={server?.name}
                    disabled={isEditServer}
                    />

                    <InputWithInnerLabel 
                    label={`${t('device_management.server_setup.organization_name')}`} 
                    name="organization" 
                    placeholder="vekin" 
                    required={true}
                    defaultValue={server?.organization}
                    
                    />
                    <InputWithInnerLabel label={`${t('device_management.server_setup.db_server')}`} name="type" type="select"  required={true}
                    options={[{label:'Influx Db',value:'influxdb'}]} defaultValue={server?.type} disabled={isEditServer}
                    />

                    <InputWithInnerLabel label={`${t('device_management.server_setup.host')}`} name="host" placeholder="https://xxxx-co.th" required={true}
                    defaultValue={server?.host}
                    />

                    <InputWithInnerLabel label={`${t('device_management.server_setup.token')}`} name="token" placeholder="xxxxx-xxxx-xxxxx-xxxxx" className="col-span-2" required={true}
                    defaultValue={server?.token}
                    />
                    <InputWithInnerLabel label={`${t('device_management.server_setup.bucket')}`} name="bucket" placeholder="vekin-bucket" className="col-span-2" required={true}
                    defaultValue={server?.bucket}
                    />

                {configStatus?.status &&
                    <span className={`absolute p-1 text-sm -bottom-4 ${true?"text-vekin":"text-red-500"}`}>
                    {configStatus.status}
                    </span> 
                 }
                    
                   
                </div>

                <StepperNav step={step} setStep={setStep} isValid={true}  prev={`< ${t('device_management.server_setup.select_server')} `} next={`${t('device_management.server_setup.save')}`} isNextSubmit={true}/>

            </form>
        }
        </>
       
     );
}
 
export default SetupIotDatabase;
